module.exports = __webpack_public_path__ + "static/img/quality.575a2439.png";